import { useEffect, useState } from "react";

export function useNowTick(active: boolean, intervalMs = 400): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!active) return;
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [active, intervalMs]);
  return now;
}

export function elapsedSec(startedAt?: string | null, now = Date.now()): number {
  if (!startedAt) return 0;
  const t = Date.parse(startedAt);
  if (Number.isNaN(t)) return 0;
  return Math.max(0, Math.round((now - t) / 1000));
}

export function clockLabel(sec: number): string {
  const s = Math.max(0, Math.round(sec || 0));
  if (s >= 90) {
    const mins = Math.floor(s / 60);
    const rest = s % 60;
    return rest ? `${mins} min ${String(rest).padStart(2, "0")} s` : `${mins} min`;
  }
  return `${s} s`;
}
